import { z } from 'zod';

const ArchivoLicitacionUiSchema = z.object({
  id: z.number(),
  nombre: z.string(),
  url_externa: z.string(),
  path_local: z.string()
});

const PreguntaRespuestaLicitacionUiSchema = z.object({
  texto: z.string(),
  tipo: z.string(),
  orden: z.number()
});

export const LicitacionDetalleUISchema = z.object({
  id: z.number(),
  nombre: z.string(),
  tematica_id: z.number(),
  resumen: z.string().nullable(),
  resumen_llm: z.string().nullable(),
  criterios_evaluacion: z.string().nullable().optional(),
  codigo_externo: z.string(),
  url_ficha_oficial: z.string().nullable().optional(),
  codigo_estado: z.number(),
  estado_licitacion: z.string(),
  fecha_creacion: z.string().nullable(),
  fecha_cierre: z.string().nullable(),
  puntaje: z.number().nullable(),
  archivos: z.array(ArchivoLicitacionUiSchema),
  preguntas_y_respuestas: z.array(PreguntaRespuestaLicitacionUiSchema),
  visto: z.boolean(),
  estado_notificacion: z.string().optional(),
  fecha_actualizacion: z.string().nullable().optional(),
  monto_estimado: z.number().nullable(),
  moneda: z.string().nullable(),
  tiempo_duracion_contrato: z.string().nullable(),
  responsable_contrato: z.string().nullable(),
  responsable_pago: z.string().nullable(),
  descripcion_licitacion: z.string().nullable(),
  puntaje_archivos: z.number().nullable().optional(),
  resumen_archivos_llm: z.string().nullable().optional(),
  requisitos_postulacion: z.string().nullable().optional(),
  resumen_procesado_filtro_palabras: z.boolean().nullable().optional(),
  archivos_procesados: z.boolean().nullable().optional(),
  resumen_procesado_filtro_llm: z.boolean().nullable().optional(),
  json_metadata: z.any().nullable().optional(),
  resumen_general: z.string().nullable().optional(),
  fuentes_resumen_general: z.any().nullable().optional(),
  fecha_adjudicacion: z.string().nullable().optional(),
  fecha_postulacion: z.string().nullable().optional(),
  adjudicado: z.boolean().nullable().optional(),
  postulado: z.boolean().nullable().optional(),
  contenido_ficha: z.string().nullable().optional()
});

export type LicitacionDetalleUI = z.infer<typeof LicitacionDetalleUISchema>; 